export const money = (v) => v == null ? "—" : `${Number(v).toLocaleString("en-US", { maximumFractionDigits: 2 })} ر.س`;

export const TYPE_LABELS = {
  auction: "المزاد العلني",
  sale: "مركبات للبيع",
  rent: "للإيجار",
  job: "وظائف لوجستية",
  invest: "استثمار وشراكة",
};

export const TYPE_PATHS = { auction: "/auctions", sale: "/sale", rent: "/rent", job: "/jobs", invest: "/invest" };

export const CATEGORIES = {
  auction: [{ v: "commercial_registration", l: "سجل تجاري" }, { v: "vehicle", l: "مركبة" }],
  sale: [{ v: "truck", l: "شاحنة" }, { v: "trailer", l: "مقطورة" }, { v: "van", l: "فان / نقل خفيف" }, { v: "equipment", l: "معدات" }, { v: "car", l: "سيارة" }],
  rent: [{ v: "truck", l: "شاحنة" }, { v: "trailer", l: "مقطورة" }, { v: "equipment", l: "معدات" }, { v: "warehouse", l: "مستودع" }, { v: "car", l: "سيارة" }],
  job: [{ v: "driver", l: "سائق" }, { v: "warehouse", l: "مستودعات" }, { v: "operations", l: "عمليات وشحن" }, { v: "management", l: "إدارة" }, { v: "other", l: "أخرى" }],
  invest: [{ v: "partnership", l: "شراكة" }, { v: "stake_sale", l: "بيع حصة" }, { v: "full_sale", l: "بيع منشأة كاملة" }, { v: "funding", l: "طلب تمويل / استثمار" }],
};

export const catLabel = (type, v) => CATEGORIES[type]?.find((c) => c.v === v)?.l || v;

export const PERIODS = { day: "يومياً", week: "أسبوعياً", month: "شهرياً", year: "سنوياً" };

export const CITIES = ["الرياض", "جدة", "الدمام", "مكة المكرمة", "المدينة المنورة", "القصيم", "تبوك", "أبها", "حائل", "جازان"];

export const STATUS_LABELS = { pending: "قيد المراجعة", approved: "معتمد", rejected: "مرفوض" };

export const FALLBACK_IMG = { auction: "/images/containers_stacked.jpg", sale: "/images/truck_2.jpg", rent: "/images/reach_stacker.jpg", job: "/images/forklift_containers.jpg", invest: "/images/truck_3.jpg" };

export const minNextBid = (l) => l.current_bid ? l.current_bid + l.min_increment : l.start_price;
